import {
  z,
  uploadedFileBaseSchema,
  uploadStatusSchema,
  createUploadedFilesSchema,
  createFileUploadValidator,
} from '@tasama/utils';

export const uploadedFileSchema = uploadedFileBaseSchema;
export const UploadStatusEnum = uploadStatusSchema;

export const getUploadDocumentsSchema = (t: (_key: string) => string) =>
  z.object({
    uploadedFiles: createUploadedFilesSchema({
      maxBytes: 5 * 1024 * 1024,
      allowedExts: ['pdf', 'png', 'jpg'],
      messages: {
        tooLarge: t('uploadDocuments.validation.tooLarge'),
        invalidType: t('uploadDocuments.validation.invalidType'),
      },
    }),
  });

export const uploadDocumentsSchema = getUploadDocumentsSchema((key) => key);

export type UploadDocumentsFormData = z.infer<typeof uploadDocumentsSchema>;
export type UploadedFile = z.infer<typeof uploadedFileSchema>;

export const uploadDocumentsDefaultValues: UploadDocumentsFormData = {
  uploadedFiles: [],
};

export const getValidateUploadDocumentsForm = (t: (_key: string) => string) =>
  createFileUploadValidator(getUploadDocumentsSchema(t));

export const validateUploadDocumentsForm = createFileUploadValidator(
  uploadDocumentsSchema
);
